import axios from 'axios';
import { IContactoInstitucional } from '@/shared/model/contacto-institucional.model';

const baseApiUrl = 'api/contacto-institucionals';

export default class ContactoInstitucionalService {
  public find(): Promise<IContactoInstitucional> {
    return new Promise<IContactoInstitucional>((resolve, reject) => {
      axios.get(`${baseApiUrl}/1`).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public update(entity: IContactoInstitucional): Promise<IContactoInstitucional> {
    return new Promise<IContactoInstitucional>((resolve, reject) => {
      axios.put(`${baseApiUrl}/1`, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }
}
